import { css } from '@emotion/react'
import { Link, Text, Theme, useTheme } from 'bold-ui'
import type { LocationDescriptor } from 'history'
import { HashLink } from 'react-router-hash-link'

import { NEWS_FONT_SIZE, NewsContentProps } from './news-commons'

interface NewsListItemLinkProps extends NewsContentProps {
  fontSize?: number
  to: LocationDescriptor
  onClick?: () => void
}

export function NewsListItemLink(props: Readonly<NewsListItemLinkProps>) {
  const { children, fontSize = NEWS_FONT_SIZE, to, onClick } = props
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Text fontSize={fontSize} component='li' css={styles.listItem}>
      <HashLink smooth to={to} style={{ textDecoration: 'none' }} onClick={onClick}>
        <Link as='span' style={{ fontWeight: 'normal' }}>
          {children}
        </Link>
      </HashLink>
    </Text>
  )
}

const createStyles = (theme: Theme) => ({
  listItem: css`
    margin-bottom: 0.25rem;
    color: ${theme.pallete.primary.main};
  `,
})
